var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLastPerformedStrikerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1415_2932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.95325 9.91309C3.41091 10.1453 2.3335 10.714 2.3335 11.3306C2.3335 12.1601 4.28766 12.8333 6.69975 12.8333C9.11183 12.8333 11.066 12.1601 11.066 11.3306C11.066 10.6761 9.85091 10.1196 8.15516 9.91309",
    stroke: "#006AB3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.40502 11.0998C6.45344 6.91494 6.2901 2.99727 6.50477 1.68477C6.6681 1.22044 6.95452 0.755521 8.83694 1.78685L10.1086 2.41044C10.8914 2.79369 11.9811 3.4056 11.5325 4.15285C11.3284 4.49294 10.8646 4.87327 9.95752 5.25944L6.40385 6.99077",
    stroke: "#006AB3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1415_2932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastPerformedStrikerIcon);
export default __webpack_public_path__ + "static/media/last_performed_striker_icon.1e4dbfe94d792bdb05bdbf5f20e5cee1.svg";
export { ForwardRef as ReactComponent };